import { css } from '@emotion/react';

import { breakpoints } from '../../styles';
import colors from '../../styles/colors';
import { p2r, PrimaryProps, SecondaryProps } from '../../styles/fonts';

const styles = ({ width = '100%', color, fontSize, lineHeight }) => css`
  width: ${width};
  font-size: ${fontSize || p2r(18)};
  font-style: normal;
  line-height: ${lineHeight || p2r(28)};
  color: ${color || colors.black};

  .text-list-title {
    padding-bottom: ${p2r(15)};
    font-size: ${p2r(22)};
    font-weight: bold;
    line-height: ${p2r(28)};
    letter-spacing: ${p2r(-1.2)};
    ${SecondaryProps}
  }

  .text-list-points {
    padding-bottom: ${p2r(23)};
  }

  .text-list-container {
    padding-left: 70px;

    li {
      font-weight: 300;
    }

    b {
      font-weight: bold;
    }
  }

  @media (max-width: ${breakpoints.tablet}px) {
    width: 100%;

    .text-list-container {
      padding-left: 10px;

      li {
        padding-left: 35px;
      }
    }
  }

  ${PrimaryProps}
`;

export default styles;
